// extracted by mini-css-extract-plugin
module.exports = {"QuizPageTitle":"QuizPage_QuizPageTitle__21_6q","QuizPage":"QuizPage_QuizPage__s0b28"};